var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wikiList"},[_c('page-title',[_vm._v(_vm._s(_vm.$t('wiki.node_list')))]),_vm._v(" "),_c('div',{staticClass:"wikiList__tree"},[_c('wiki-tree')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }